import { ExternalLink } from "lucide-react";
import { AIRBNB_URL } from "@/data/property";

/**
 * Live OwnerRez availability + booking widget.
 * Widget snippet comes from OwnerRez → Settings → Widgets.
 */
const OWNERREZ_WIDGET =
  "https://app.ownerrez.com/widgets/b2bac7a516ae4119be44e70cf4c554f4?view=form";

export default function Availability() {
  return (
    <div
      data-testid="availability-section"
      className="rounded-2xl overflow-hidden bg-white border border-[#0E2A47]/8 shadow-[0_4px_40px_rgba(14,42,71,0.06)]"
    >
      <div className="flex items-center justify-between px-5 py-3 border-b border-[#0E2A47]/8 bg-[#F1E8DA]/30">
        <div className="text-xs uppercase tracking-widest text-[#0E2A47]/60 font-body">
          Live availability · Book direct
        </div>
        <a
          data-testid="availability-open-listing"
          href={AIRBNB_URL}
          target="_blank"
          rel="noreferrer"
          className="inline-flex items-center gap-1.5 text-sm font-display text-[#1FB6C9] hover:text-[#0E2A47]"
        >
          Full listing <ExternalLink size={14} />
        </a>
      </div>
      <iframe
        data-testid="availability-iframe"
        title="Grandview Estate — Availability & Booking"
        src={OWNERREZ_WIDGET}
        loading="lazy"
        className="w-full block bg-white"
        style={{ height: "780px", border: 0 }}
        sandbox="allow-scripts allow-same-origin allow-popups allow-forms allow-top-navigation-by-user-activation"
        referrerPolicy="no-referrer-when-downgrade"
      />
      <div className="px-5 py-3 border-t border-[#0E2A47]/8 bg-white text-xs text-[#0E2A47]/60 font-body flex items-center justify-between flex-wrap gap-2">
        <span>Instant confirmation — save 15% vs other platforms when you book direct.</span>
        <a
          href={AIRBNB_URL}
          target="_blank"
          rel="noreferrer"
          className="inline-flex items-center gap-1.5 rounded-full bg-[#1FB6C9] text-white px-4 py-1.5 font-display text-xs"
        >
          Book Now <ExternalLink size={12} />
        </a>
      </div>
    </div>
  );
}
